import styled from '@emotion/styled'
import { Icon, TIcons, Tooltip } from '@yuno/design-system-web'
import { IconContainer } from '../../style'
import { useTranslation } from 'react-i18next'

interface TableActionProps {
  allowed: boolean
  icon: TIcons
  onClick: () => void
  hoverColor?: string
}

export const StyledIcon = styled(Icon)<{
  hoverColor?: string
}>`
  &:hover {
    color: ${({ hoverColor }) => hoverColor};
  }
`

export const TableAction = ({
  allowed,
  icon,
  onClick,
  hoverColor,
}: TableActionProps) => {
  const { t } = useTranslation()

  return (
    <Tooltip
      disableHoverListener={allowed}
      title={t('noAccess')}
      color="default"
      arrow
    >
      <span>
        <IconContainer disabled={!allowed} onClick={onClick}>
          <StyledIcon
            hoverColor={hoverColor}
            name={icon}
            size="16px"
            weight="thin"
          />
        </IconContainer>
      </span>
    </Tooltip>
  )
}
